export default __webpack_public_path__ + "static/media/loading.28afb12f.gif";